@import "styles/_variables.css";
@import "styles/_semantics.css";
@import "styles/_global.css";
@import "styles/_media.css";
@import "styles/_layout.css";

.overlayWhite {
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 1000001;
  top: 0;
  left: 0;
  background-color: var(--color-white);
  overflow-y: hidden;
}
